/* NutriZoé : navigation de la galerie produit sur ordinateur (11/10/2026), sortie du modèle le 25/10/2026 */
(() => {
  'use strict';
  const key = '__nutrizoeDesktopGallery';
  if (window[key]) { window[key].refresh(); return; }
  const desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const instances = new Map();

  function enhance(root) {
    const viewer = root.querySelector('[id^="GalleryViewer-"]');
    const slides = root.querySelector('[id^="Slider-Gallery-"]');
    const thumbnails = root.querySelector('[id^="Slider-Thumbnails-"]');
    if (!viewer || !slides || !thumbnails) return null;
    const getItems = () => Array.from(thumbnails.querySelectorAll('li[data-target]')).filter(item => {
      const id = item.getAttribute('data-target');
      return item.querySelector('button') && Array.from(slides.children).some(slide => slide.getAttribute('data-media-id') === id);
    });
    if (getItems().length < 2) return null;
    const controller = new AbortController();
    const on = (target, event, listener, options = {}) => target.addEventListener(event, listener, { ...options, signal: controller.signal });
    const oldTabindex = root.getAttribute('tabindex');
    root.classList.add('nz-desktop-gallery');
    if (oldTabindex === null) root.setAttribute('tabindex', '0');
    const imageControlAttributes = new Map();
    function prepareImageControls() {
      viewer.querySelectorAll('.product__modal-opener--image .product__media-toggle').forEach(button => {
        if (imageControlAttributes.has(button)) return;
        imageControlAttributes.set(button, {
          'aria-haspopup': button.getAttribute('aria-haspopup'),
          'aria-label': button.getAttribute('aria-label'),
          title: button.getAttribute('title')
        });
        button.removeAttribute('aria-haspopup');
        button.setAttribute('aria-label', 'Afficher la photo suivante');
        button.setAttribute('title', 'Photo suivante');
      });
    }

    function arrow(direction, label, path) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nz-gallery-arrow nz-gallery-arrow--' + direction;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-controls', slides.id);
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"></path></svg>';
      viewer.appendChild(button);
      return button;
    }
    const previous = arrow('previous', 'Photo précédente', 'M15 5l-7 7 7 7');
    const next = arrow('next', 'Photo suivante', 'M9 5l7 7-7 7');
    const status = document.createElement('span');
    status.className = 'nz-gallery-status';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    root.appendChild(status);
    let lastActive = null;
    let pendingFrame = 0;

    function currentIndex(items) {
      const active = slides.querySelector('.is-active[data-media-id]');
      const id = active && active.getAttribute('data-media-id');
      const index = items.findIndex(item => item.getAttribute('data-target') === id);
      return index >= 0 ? index : Math.max(0, items.findIndex(item => item.querySelector('[aria-current="true"]')));
    }
    function update() {
      pendingFrame = 0;
      prepareImageControls();
      const items = getItems();
      const index = currentIndex(items);
      previous.disabled = index <= 0;
      next.disabled = index >= items.length - 1;
      const active = items[index];
      if (!active || active === lastActive) return;
      lastActive = active;
      status.textContent = 'Photo ' + (index + 1) + ' sur ' + items.length;
      const itemBox = active.getBoundingClientRect();
      const listBox = thumbnails.getBoundingClientRect();
      let offset = 0;
      if (itemBox.left < listBox.left) offset = itemBox.left - listBox.left;
      else if (itemBox.right > listBox.right) offset = itemBox.right - listBox.right;
      if (offset) thumbnails.scrollBy({ left: offset, behavior: 'auto' });
    }
    function scheduleUpdate() {
      if (!pendingFrame) pendingFrame = requestAnimationFrame(update);
    }
    function step(direction, loop = false) {
      const items = getItems();
      if (!items.length) return;
      const index = currentIndex(items);
      const targetIndex = loop ? (index + direction + items.length) % items.length : index + direction;
      const target = items[targetIndex];
      if (!target) return;
      target.querySelector('button').click();
      scheduleUpdate();
    }
    on(previous, 'click', () => step(-1));
    on(next, 'click', () => step(1));
    on(root, 'keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      step(event.key === 'ArrowRight' ? 1 : -1);
    });

    let gesture = null;
    let suppressClickUntil = 0;
    on(viewer, 'pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!event.target.closest('.product__modal-opener--image')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dragging: false };
    });
    on(window, 'pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
        gesture = null;
        return;
      }
      if (!gesture.dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        gesture.dragging = true;
        viewer.setPointerCapture(event.pointerId);
        root.classList.add('nz-gallery-dragging');
      }
      if (gesture.dragging) event.preventDefault();
    }, { passive: false });
    function finish(event, cancelled) {
      if (!gesture || event.pointerId !== gesture.id) return;
      const ended = gesture;
      gesture = null;
      root.classList.remove('nz-gallery-dragging');
      if (viewer.hasPointerCapture(event.pointerId)) viewer.releasePointerCapture(event.pointerId);
      if (!ended.dragging) return;
      suppressClickUntil = performance.now() + 500;
      if (cancelled) return;
      const distance = event.clientX - ended.x;
      if (Math.abs(distance) >= 45) step(distance < 0 ? 1 : -1);
    }
    on(window, 'pointerup', event => finish(event, false));
    on(window, 'pointercancel', event => finish(event, true));
    on(viewer, 'lostpointercapture', event => finish(event, true));
    on(viewer, 'dragstart', event => {
      if (event.target.closest('.product__modal-opener--image')) event.preventDefault();
    });
    on(viewer, 'click', event => {
      if (performance.now() < suppressClickUntil) {
        suppressClickUntil = 0;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const image = event.target.closest('.product__modal-opener--image');
      if (!image || !viewer.contains(image)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const moveFocus = event.detail === 0 || image.contains(document.activeElement);
      step(1, true);
      if (moveFocus) {
        const activeControl = slides.querySelector('.is-active .product__media-toggle');
        if (activeControl) activeControl.focus({ preventScroll: true });
      }
    }, { capture: true });

    let wheelTotal = 0;
    let wheelConsumed = false;
    let wheelLast = 0;
    on(viewer, 'wheel', event => {
      if (event.ctrlKey || Math.abs(event.deltaX) <= Math.abs(event.deltaY) * 1.2 || !event.deltaX) return;
      const now = performance.now();
      if (now - wheelLast > 180) { wheelTotal = 0; wheelConsumed = false; }
      wheelLast = now;
      event.preventDefault();
      if (wheelConsumed) return;
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewer.clientWidth : 1;
      wheelTotal += event.deltaX * unit;
      if (Math.abs(wheelTotal) >= 65) {
        wheelConsumed = true;
        step(wheelTotal > 0 ? 1 : -1);
      }
    }, { passive: false });

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(slides, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-media-id'] });
    observer.observe(thumbnails, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current', 'data-target'] });
    update();
    return () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(pendingFrame);
      if (gesture && viewer.hasPointerCapture(gesture.id)) viewer.releasePointerCapture(gesture.id);
      previous.remove();
      next.remove();
      status.remove();
      imageControlAttributes.forEach((attributes, button) => {
        Object.entries(attributes).forEach(([name, value]) => {
          if (value === null) button.removeAttribute(name);
          else button.setAttribute(name, value);
        });
      });
      root.classList.remove('nz-desktop-gallery', 'nz-gallery-dragging');
      if (oldTabindex === null) root.removeAttribute('tabindex');
      else root.setAttribute('tabindex', oldTabindex);
    };
  }

  function refresh() {
    instances.forEach((destroy, root) => {
      if (!desktop.matches || !root.isConnected) { destroy(); instances.delete(root); }
    });
    if (!desktop.matches) return;
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(root => {
      if (instances.has(root) || root.closest('quick-add-modal')) return;
      const destroy = enhance(root);
      if (destroy) instances.set(root, destroy);
    });
  }
  window[key] = { refresh };
  desktop.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(refresh));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
